
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {ProductMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {ProductComponent} from "./product.component";
import {ProductFormComponent} from "./productForm.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RouterModule} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {MatTabsModule} from "@angular/material/tabs";
import {SupplierOrderModule} from "../supplierOrder/supplierOrder.module";
import {SecurityModule} from "../security/security.module";
import {StockComponent} from "./stock.component";
import {ProductSaleReportComponent} from "./productSaleReport.component";
import {ProductResolve} from "./providers/product.resolve";
import {ProductTotalSummaryResolve} from "./providers/productTotalSummary.resolve";
import {ProductTotalSummaryByYearResolve} from "./providers/productTotalSummaryByYear.resolve";
import {HelpersModule} from "../helpers/helpers.module";
import {MatDatepickerModule} from "@angular/material/datepicker";

@NgModule({
    declarations: [
        ProductComponent,
        ProductMainSidebarComponent,
        ProductFormComponent,
        StockComponent,
        ProductSaleReportComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatToolbarModule,
        TranslateModule,
        MatTabsModule,
        SupplierOrderModule,
        SecurityModule,
        HelpersModule,
        MatDatepickerModule,
    ],
    providers: [
        ProductResolve,
        ProductTotalSummaryResolve,
        ProductTotalSummaryByYearResolve,
    ],
    bootstrap: [
        ProductComponent,
        ProductFormComponent,
        StockComponent,
        ProductSaleReportComponent,
    ]
})
export class ProductModule { }
